var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.359.25-12.67 12.8H0V.25h25.359zm-2.091.872H.871v11.055h11.453L23.268 1.122zM4.784 3.65c.7 0 1.556.194 2.176.5l-.67 1.13c-.676-.318-1.017-.349-1.402-.368-.576-.03-.866.17-.87.386-.005.261.542.5 1.06.662.784.242 1.78.565 1.932 1.5l1.432-3.71h1.663l1.677 4.437V3.749h1.92c1.835 0 2.698.637 2.698 2.023 0 1.245-.889 1.987-2.388 1.987h-.62v1.792H10.55l-.284-.857a3.37 3.37 0 0 1-1 .15 3.34 3.34 0 0 1-1.025-.157l-.292.864H6.204l.191-.499-.069.057c-.435.34-.98.528-1.652.54l-.1.001A4.53 4.53 0 0 1 2.4 9.087l.593-1.145c.642.369 1.046.451 1.59.442.282-.007.486-.057.618-.19a.418.418 0 0 0 .126-.29c.006-.3-.43-.439-.962-.6-.433-.13-.922-.307-1.305-.58-.454-.324-.67-.73-.66-1.303a1.55 1.55 0 0 1 .46-1.089c.422-.425 1.103-.682 1.92-.682zM9.27 5.576h-.01l-.61 1.867c.182.067.392.106.615.106.219 0 .423-.037.602-.1L9.27 5.576zm4.546-.606h-.423v1.505h.423c.563 0 1.013-.181 1.013-.76 0-.563-.45-.745-1.013-.745z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.41333eae.svg";
export { ForwardRef as ReactComponent };